var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"counter-item"},[(_vm.items.length)?_c('chart-area',{staticStyle:{"width":"100%","height":"100%"},attrs:{"colors":[
      ['#0000ff', '#00ccff'],
      ['#ff0000', '#ffff00'],
      ['#00ff9d', '#0a9d00']
    ],"values":_vm.items,"grid":_vm.grid,"dispose-before-update":this.disposeBeforeUpdate,"click-handler":this.clickHandler,"type":"time"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }